<template>
  <button
    class="button"
    :class="outline ? 'button--outline' : 'button--solid'"
    @click="$emit('clicked', $event)"
    :disabled="disabled"
  >
    <span>{{ label }}</span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clicked'],
}
</script>

<style lang="scss">
.button {
  @include flex-center;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: $font-weight-medium;
  line-height: 1.38;
  height: fit-content;
  min-width: 136px;
  white-space: nowrap;
  padding: 11px 16px;
  transition: 0.2s;

  &:focus-visible {
    outline: 2px solid $color-info-primary;
    outline-offset: 2px;
  }

  svg {
    margin-left: 4px;
  }

  &--solid {
    background-color: $color-yellow-primary;
    border: none;

    &:hover,
    &:focus-visible {
      background-color: $color-yellow-dark;
      text-decoration: underline;
    }

    &:disabled {
      background-color: $color-grey-dark;
    }
  }

  &--outline {
    background-color: white;
    border: 2px solid $color-yellow-primary;
    padding: 9px 16px; // because of 2px borders

    &:hover:not(:disabled),
    &:focus-visible {
      background-color: $color-yellow-dark;
      border-color: $color-yellow-dark;
      text-decoration: underline;
    }

    &:disabled {
      border-color: $color-grey-darker;
    }
  }

  &:disabled {
    cursor: not-allowed;

    span {
      color: $color-text-secondary;
    }
  }
}
</style>
